
import {
    IIAX_DMS_Sales_Document_Line, IIAX_DMSPurch_DocumentLine, IFDRW_Deferral_Schedule,
    IDeferral_Schedule_Line, IFDDI_DMS_Purchase_Document, IFDDI_DMS_Sales_Document, RwfBootstrap, IRwfBootstrapParameters
} from "@common/rwf";
import {
    NavClientService, NavPageItem, Observable, NavPropertyItem,
    ObservableArray, IObservableArray, NavGridVisibility, INavPageClientInfo
} from "@common/navdata";
import { fn, IInfOperation } from "@common/utils";
import { GetGridDataSource, UpdateGridOptions, ReplaceObservableData, constants } from "@common/navkendo";
import { FDDI_DMS_Purchase_Document, FDDI_DMS_Sales_Document } from "@common/rwf/rwf.const";
import { CompatibilityService } from '@common/services/compatibilityservice';
import { INavUiPageInfo } from '@common/rwfsignalrtypes';

type RootDeferralSource = NavPageItem<IFDDI_DMS_Purchase_Document | IFDDI_DMS_Sales_Document>;
export const FDRW_Deferral_Schedule = "FDRW_Deferral_Schedule";
export class CtrlDeferralSchedule extends Observable {
    /** DeferralSchedule UI as Directive */
    static Directive = [function (): ng.IDirective {
        return {
            controller: CtrlDeferralSchedule,
            controllerAs: "vm",
            template: require("./deferralschedule.html"),
            scope: {
                item: "=item"
            },
            link: ($scope, instanceElement, attributes, ctrl) => {
                if (attributes.reference) {
                    $scope.$parent[attributes.reference] = ctrl;
                    $scope.$on("$destroy", () => delete $scope.$parent[attributes.reference]);
                }
            }
        };
    }];
    static $inject = ["$scope", "NavClient", "CompatibilityService"];
    constructor(
        $scope: ng.IScope & { /** attached via directive  */ item: NavPageItem },
        public readonly NavClient: NavClientService,
        public readonly $c: CompatibilityService) {
        super();

        const Rwf = $c.resolve("Rwf");
        const RwfBootstrap = Rwf("RwfBootstrap");
        let RwfApplication = Rwf("RwfApplication");
        let rwfBootstrap: IRwfBootstrapParameters;
        RwfBootstrap.Resolve.then(rwf => {
            if (rwf.RwfSettings.CheckPages.FDRW_Deferral_Schedule === false || rwf.RwfSettings.User.IsStandalone) {
                this.show = false;
                return;
            }
            rwfBootstrap = rwf;
            $scope.$watch<RootDeferralSource>("item", (newItem) => this.SetCurrentPageItem(newItem));
        });

        this.ModalShowNavPage = {
            Hint: 'Abgrenzungsplan bearbeiten',
            Icon: { "k-icon": true, "k-i-edit": true },
            Enabled: false,
            Execute: () => {
                if (!this.Keys) {
                    throw new Error('Kein Abgrenzungsplan vorhanden!');
                }
                if (!this.allowedit) {
                    throw new Error('Bearbeitung nicht möglich!');
                }

                const PageId = 5387196;
                const HostPageId = 5387172;
                /** unique identifier as null op filter */
                const uidDummyFilter = `*|${fn.id(10)}`;

                var qIgnore = true; // TODO : WTF!!! Learn how to use BehaviorSubjects : will be called with current state
                const subscription = $c.resolve("RwfSignalR").Register("onNavUiClosed", (e: INavUiPageInfo) => {
                    if (qIgnore) {
                        return;
                    }
                    if ((e && e.PageId) == PageId) {
                        // timeout: wOut: Page in nav not yet 'fully' closed -->  user confirmation on unsaved changes ...
                        window.setTimeout(teardown, 500);
                    }
                });
                qIgnore = false;

                let teardown = fn.once(() => {
                    clearInterval(waitWndClose);
                    subscription.unsubscribe();
                    if (dlg) {
                        dlg.then(d => d.closeDialog());
                    }
                    teardown = fn.noop;
                    if (wnd) {
                        wnd.close();
                    }
                    this.deferralDataChanged(this.line, this.line.Root.MetaData.PageName === FDDI_DMS_Sales_Document);
                });
                $scope.$on("$destroy", teardown);
                let BaseWebUrl = rwfBootstrap.RwfSetup.NAVWebClientURL;
                if (!BaseWebUrl) {
                    throw new Error("NAVWebClientURL not set!");
                }
                const Keys = this.Keys;
                const qParams = [
                    `'Deferral Doc. Type' IS '${Keys.Deferral_Doc_Type}'`,
                    //`'Gen. Jnl. Template Name' IS '${Keys.Gen_Jnl_Template_Name || ''}'`,
                    //`'Gen. Jnl. Batch Name' IS '${Keys.Gen_Jnl_Batch_Name || ''}'`,
                    `'Gen. Jnl. Batch Name' IS '${uidDummyFilter}'`, // passthrough unique identifier
                    `'Document Type' IS '${this.Keys.Document_Type || ''}'`,
                    `'Document No.' IS '${Keys.Document_No}'`,
                    `'Line No.' IS '${Keys.Line_No}'`
                ].join(" AND ");

                const hasAlreadyParams = BaseWebUrl.indexOf('?') > 0;
                const fullUrl = `${BaseWebUrl}${hasAlreadyParams ? '&' : '?'}page=${HostPageId}&&redirect=0&filter=${encodeURIComponent(qParams)}`;
                let wnd = window.open(fullUrl, "_blank", "width=1200,height=900,menubar=no,toolbar=no");
                RwfApplication.NotifyNavUiOpened({ PageId: PageId, RecordId: "", UserId: rwfBootstrap.RwfUser.NAVUserName, Identifier : uidDummyFilter }, RwfApplication);
                let waitWndClose = setInterval(() => {
                    try {
                        if (wnd.closed) {
                            teardown();
                        }
                    } catch (err) {
                        teardown();
                    }
                }, 1000);
                const dlg = $c.resolve("DialogService").ShowWindow({
                    controller: [function() {
                        this.close = () => dlg.then(d => d.closeDialog());
                    }],
                    controllerAs: "vmp",
                    windowOptions: {
                        modal: true,
                        actions: ["Close"],
                    },
                    template: require('./editprogress.html')
                 });
                 dlg.then(d => d.close.then(teardown));
            }
        };
    }

    public readonly DisplayData: IObservableArray<IDeferral_Schedule_Line> = <any>new ObservableArray([]);

    public ModalShowNavPage: IInfOperation & { Hint: string };

    public GridOptions: kendo.ui.GridOptions;

    /** Current Deferral Schhdule */
    public Current: IFDRW_Deferral_Schedule;

    public CurrentError: string;

    public get Loading() { return !!this.currentRefresh; }

    public Initialized?: true;
    public Keys: { [name in keyof IFDRW_Deferral_Schedule]?: any };
    public get Show() { return this.show || !!this.CurrentError; }

    public CurrentTitle = "Abgrenzungsplan";
    private show: boolean = false;
    private allowedit: boolean = true;
    private currentRefresh: PromiseLike<any>;

    /** Set Current Root Source Item */
    SetCurrentPageItem(item: NavPageItem<IFDDI_DMS_Purchase_Document | IFDDI_DMS_Sales_Document>) {
        // Ignore unmatched pages
        if (item && [FDDI_DMS_Purchase_Document, FDDI_DMS_Sales_Document].indexOf(item.PageName) < 0) {
            item = undefined;
        }
        const EV_SetCurrentItem = "SetCurrentItem";
        this.trigger(EV_SetCurrentItem);
        const pageName = item && item.PageName;
        var isSales = pageName == FDDI_DMS_Purchase_Document ? false : (pageName == FDDI_DMS_Sales_Document ? true : undefined);
        const masterLineProperty = item && item instanceof NavPageItem && item.ClientInfo.MasterLineProperty;
        const linePropDeferalCode: any = (masterLineProperty + ".Deferral_Code");
        const refreshShow = () => {
            this.show = lineData && lineData.Items.filter(item => item.Model.Deferral_Code).length > 0;
            this.allowedit = item && item.Anchor.Readonly.GetValue(linePropDeferalCode, item) !== true;
         };
        if (item && pageName && masterLineProperty && typeof isSales === "boolean") {
            var lineData = item.GetLineData(item.ClientInfo.MasterLineProperty);
            if (lineData) {
                const setSingleItem = () => {
                    if (lineData && lineData.SelectedIds && lineData.SelectedIds.length == 1) {
                        var lineItem = lineData.GetItems(lineData.SelectedIds[0])[0];
                    }
                    this.SetCurrentLineSource(lineItem, isSales);
                };
                this.one(EV_SetCurrentItem, item.RegisterPropertyChanged(linePropDeferalCode, refreshShow));
                this.one(EV_SetCurrentItem, lineData.RegisterSelectionChanged(setSingleItem));
                setSingleItem();
            } else {
                this.SetCurrentLineSource(undefined);
            }
        } else {
            this.SetCurrentLineSource(undefined);
        }
        refreshShow();
    }

    /** Set Current Line Source Item */
    SetCurrentLineSource(line: NavPropertyItem<IIAX_DMS_Sales_Document_Line | IIAX_DMSPurch_DocumentLine>, isSales?: boolean) {
        if (line === this.line) {
            return;
        }
        const EV_SetCurrentSource = "SetCurrentSource";
        /** Refresh Display Line Data */
        let setDisplayData = (l?: IDeferral_Schedule_Line[]) => ReplaceObservableData(this.DisplayData, l || [], item => item.Key);
        this.trigger(EV_SetCurrentSource);
        this.line = line;
        this.ModalShowNavPage.Enabled = !!line;
        if (!line) {
            delete this.currentRefresh;
            this.Current = undefined;
            setDisplayData();
        } else {
            // Deferral Schedule might be changed on change of these line props
            const changeActiveProps: (keyof IIAX_DMS_Sales_Document_Line | IIAX_DMSPurch_DocumentLine)[] =
                ["Deferral_Code", "Line_Amount", "PDate"];
            const registerActiveProps = changeActiveProps.map(p => <any>(line.MetaData.PropertyName + "." + p));
            this.one(EV_SetCurrentSource,
                line.RegisterPropertyChanged(registerActiveProps, () => this.deferralDataChanged(line, isSales)));
            this.deferralDataChanged(line, isSales);
        }
    }
    private line: NavPropertyItem<IIAX_DMS_Sales_Document_Line | IIAX_DMSPurch_DocumentLine>;

    setDisplayData(l?: IDeferral_Schedule_Line[]) {
        ReplaceObservableData(this.DisplayData, l || [], item => item.Key);
    }

    deferralDataChanged(line: NavPropertyItem<IIAX_DMS_Sales_Document_Line | IIAX_DMSPurch_DocumentLine>, isSales: boolean) {
        const setDisplayData = fn.proxy(this.setDisplayData, this);
        this.CurrentTitle = "Abgrenzungsplan";
        this.Current = undefined;
        delete this.Keys;
        setDisplayData();
        const currLine = line.Model;
        var defCode = currLine && currLine.Deferral_Code;

        if (!defCode) {
            delete this.currentRefresh;
            setDisplayData();
        } else {
            var resetRefresh = () => {
                if (this.currentRefresh == startedRefresh) {
                    delete this.currentRefresh;
                    return true;
                }
                return false;
            };
            this.Initialized = true;
            var startedRefresh = this.currentRefresh = this.NavClient.Read<IFDRW_Deferral_Schedule>({
                PageName: FDRW_Deferral_Schedule,
                Keys: this.Keys = {
                    Deferral_Doc_Type: isSales ? 1 : 0,
                    Gen_Jnl_Template_Name: " ",
                    Gen_Jnl_Batch_Name: " ",
                    Document_Type: currLine.Document_Type,
                    Document_No: currLine.Document_No,
                    Line_No: currLine.Line_No,
                },
                NavUrl: line.Root.ClientInfo.Url,
            }).then(r => {
                if (resetRefresh()) {
                    this.ensureGridOptions(r.Client);
                    this.Current = r.Data;
                    const lineData = r.Data && r.Data.DeferralSheduleSubform || [];
                    setDisplayData(lineData);
                    if (lineData.length) {
                        const firstLine = lineData[0];
                        this.CurrentTitle = `Abgrenzungsplan (${defCode}) - Abgrenzungstotalbetrag: ${kendo.format(constants.KendoCurrencyFormat, firstLine.TotalDeferral)}`;
                    }
                    delete this.CurrentError;
                }
            }, err => {
                if (resetRefresh()) {
                    this.Current = undefined;
                    setDisplayData([]);
                    this.CurrentError = fn.resolveToError(err);
                }
            });
        }
    }
    /** Ensure Grid Options attached to UI if not yet done */
    private ensureGridOptions(client: INavPageClientInfo<IFDRW_Deferral_Schedule>) {
        if (!this.GridOptions) {
            var MetaData = client.MetaData.PropsByName.DeferralSheduleSubform.ArrayProperties;
            const cols = MetaData.Properties.filter(item => item.Invisible !== true
                && item.GridVisibility !== NavGridVisibility.ForcedRemove).map(item => MetaData.GetColumn(item));
            const gridOptions = {
                columns: cols,
                dataSource: GetGridDataSource(this.DisplayData, MetaData.Model),
                resizable: true,
                selectable: 'row'
            };
            UpdateGridOptions(this.GridOptions = gridOptions);
        }

        return this.GridOptions;
    }
}
